
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsRefundReasonGrid extends Serenity.EntityGrid<PsRefundReasonRow, any> {
        protected getColumnsKey() { return PsRefundReasonColumns.columnsKey; }
        protected getDialogType() { return PsRefundReasonDialog; }
        protected getIdProperty() { return PsRefundReasonRow.idProperty; }
        protected getInsertPermission() { return PsRefundReasonRow.insertPermission; }
        protected getLocalTextPrefix() { return PsRefundReasonRow.localTextPrefix; }
        protected getService() { return PsRefundReasonService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}